var _defs, _path, _path2, _path3, _circle, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModelingMoveVerticallySvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#009ad9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingMoveVertically_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.72,7.31a17.29,17.29,0,0,1-10,.27,17.78,17.78,0,0,1-2.4-1C15.18,6.06,14.54,5.79,14,6s-.6.5-.93,1.38a5.92,5.92,0,0,1-1.84,2.84,6.16,6.16,0,0,1-2.64,1.13l2.12,1.05c2.32-2.23,4.5-3.26,6.49-3.07a8,8,0,0,1,2.46.77A7.82,7.82,0,0,0,23,11h0a7.53,7.53,0,0,0,1.56-.17L30.16,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,11.93A6.41,6.41,0,0,0,17,11.32c-1.26-.12-2.73.56-4.38,2L16,15l4.79-2.37A13.67,13.67,0,0,1,18.82,11.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.94,8.65a4.13,4.13,0,0,0,1.22-2,3.69,3.69,0,0,1,2.12-2.55c1.37-.5,2.61.07,3.91.67a17.43,17.43,0,0,0,2.17.88,13.85,13.85,0,0,0,6.56.25L16,1,1.84,8,4.61,9.39C7.09,9.74,8.88,9.49,9.94,8.65Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 29,
    r: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15 25 17 25 17 21 20.32 21 15.99 15.89 11.73 21 15 21 15 25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingMoveVerticallySvg);
export default __webpack_public_path__ + "static/media/ModelingMoveVertically_svg.818f62b060f12224d3508a767b958cd5.svg";
export { ForwardRef as ReactComponent };